export const LOAD_DATA = Symbol('LOAD_DATA');
export const LOAD_USER_DATA = Symbol('LOAD_USER_DATA');
export const LOAD_EMPTY_DATA = Symbol('LOAD_EMPTY_DATA');
export const PAGE_NUMBER_CHANGE = Symbol('PAGE_NUMBER_CHANGE');
export const PAGE_SIZE_CHANGE = Symbol('PAGE_SIZE_CHANGE');
export const PAGE_CHANGE = Symbol('PAGE_CHANGE');
export const DATA_SORT = Symbol('DATA_SORT');
export const SELECT_ITEM = Symbol('SELECT_ITEM');
export const UPDATE_START_INDEX = Symbol('UPDATE_START_INDEX');
export const LOAD_USERSESSION_DATA = Symbol('LOAD_USERSESSION_DATA');
export const ON_CHECK_FILTER_COLUMN = Symbol('ON_CHECK_FILTER_COLUMN');
export const LOAD_TAB_DATA = Symbol('LOAD_TAB_DATA');
export const LOAD_ENCDATA = Symbol('LOAD_ENCDATA');
export const LOAD_ERROR_MESSSAGE = Symbol('LOAD_ERROR_MESSSAGE');
export const CREATE_FILTER = Symbol('CREATE_FILTER');
export const CLEAR_FILTERS = Symbol('CLEAR_FILTERS');
export const REMOVE_FILTER = Symbol('REMOVE_FILTER');
export const UPDATE_FILTERS = Symbol('UPDATE_FILTERS');
export const LOAD_FILTER_DATA = Symbol('LOAD_FILTER_DATA');
export const TOGGLE_MENU = Symbol('TOGGLE_MENU');
export const SAVE_NEWTAB = Symbol('SAVE_NEWTAB');
export const REMOVE_TAB = Symbol('REMOVE_TAB');
export const SWAP_TAB = Symbol('SWAP_TAB');
export const CLEAR_ERRORS = Symbol('CLEAR_ERRORS');
export const EDIT_TAB = Symbol('EDIT_TAB');
export const SET_ELAPSED_TIME = Symbol('SET_ELAPSED_TIME');
export const PRINT_TICKET = Symbol('PRINT_TICKET');
export const LOAD_TICKET_DATA = Symbol('LOAD_TICKET_DATA');
export const LOAD_TECH_DATA = Symbol('LOAD_TECH_DATA');
export const LOAD_LASTUPDATEDDATE = Symbol('LOAD_LASTUPDATEDDATE');
export const LOAD_OWNERTEAM_DATA = Symbol('LOAD_OWNERTEAM_DATA');
export const CHANGE_OWNER_TEAM = Symbol('CHANGE_OWNER_TEAM');
export const LOAD_TICKETCATEGORY_DATA = Symbol('LOAD_TICKETCATEGORY_DATA');
export const SHOW_HIDE_LOADER = Symbol('SHOW_HIDE_LOADER');
export const START_RESET_TIMER = Symbol('START_RESET_TIMER');
export const SAVE_FILTER_INFO = Symbol('SAVE_FILTER_INFO');
export const UNDO_FILTER_INFO = Symbol('UNDO_FILTER_INFO');
export const TICKET_CHECKBOX_ARRAY=Symbol('TICKET_CHECKBOX_ARRAY');
export const LOAD_CELL_DATA=Symbol('LOAD_CELL_DATA');


// WEBPACK FOOTER //
// ./app/tickets/types.jsx